  
import React from 'react'

function Register() {
  

  return (
    <div>
  
    </div>
  )
}

export default Register
